import { Grid } from "@material-ui/core";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import LynxSelect from "components/LynxSelect/LynxSelect";
import { observer } from "mobx-react-lite";
import { EventStatus } from "models/thorEventModels/EventDetails";
import React, { useState } from "react";
import { useStore } from "store/StoreConfigs";
import { eventLevelInformationStyles } from "./EventLevelInformationStyles";

export default observer(function EventLevelInformation() {
    const classes = eventLevelInformationStyles();
    const { thorEventViewStore, identityStore } = useStore();
    const [clinicalOrCommercial, setClinicalOrCommercial] = useState("Commercial");

    const isUserHavePermission: boolean =
        identityStore.userInfo?.email === thorEventViewStore.eventDetails.reviewerUserId ||
        identityStore.userInfo?.email === thorEventViewStore.eventDetails.qaUserId;

    const handleEventTypeChange = (e: any) => {
        thorEventViewStore.setEventType({
            eventType: e.target.value,
            eventId: thorEventViewStore.eventDetails.eventId,
            customerId: identityStore.currentCustomerId,
        });
    };
    return (
        <div className={classes.main}>
            <Grid container spacing={3} xs={12}>
                <Grid item>
                    <LynxSelect
                        // disabled={thorEventViewStore.eventDetails.eventStatusId === EventStatus.Closed || !isUserHavePermission}
                        disabled={true}
                        label={"Clinical or Commercial"}
                        isMultiple={false}
                        value={clinicalOrCommercial}
                        options={[
                            {
                                itemName: "Clinical",
                                itemValue: "Clinical",
                            },
                            {
                                itemName: "Commercial",
                                itemValue: "Commercial",
                            },
                        ]}
                        onChange={(e) => {
                            setClinicalOrCommercial(e.target.value);
                        }}
                        margin={"-5px 0px 0px 0px"}
                    />
                </Grid>
                <Grid item>
                    {thorEventViewStore.isTypeSet ? (
                        <div className={classes.smallIndicator}>
                            <LoadingIndicator />
                        </div>
                    ) : (
                        <div>
                            <LynxSelect
                                disabled={
                                    thorEventViewStore.eventDetails.eventStatusId === EventStatus.Closed ||
                                    !isUserHavePermission
                                }
                                margin={"-5px 0px 0px 10px"}
                                label={"Type of Event"}
                                isMultiple={false}
                                value={thorEventViewStore.eventDetails.eventType}
                                options={[
                                    {
                                        itemName: "Transportation",
                                        itemValue: 0,
                                    },
                                    {
                                        itemName: "Site",
                                        itemValue: 1,
                                    },
                                ]}
                                onChange={handleEventTypeChange}
                            />
                        </div>
                    )}
                </Grid>
            </Grid>
        </div>
    );
});
